module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Satisfaction Score"},"de":{"title":"Zufriedenheit-Score"},"fr":{"title":"Score de satisfaction"},"it":{"title":"Punteggio di soddisfazione"}}')
  delete Component.options._Ctor
}
